module.exports = "<div class=\"col s12 m6\"> <card :revealed=false> <card-image :src=imageUrl activator></card-image> <card-content> <card-title class=red-text>Card Title</card-title> </card-content> <card-reveal> <card-title class=blue-text>Reveal title</card-title> <p>Here is some more information about this product that is only revealed once clicked on.</p> </card-reveal> </card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/cards/card-reveal.vue
 ** module id = 201
 ** module chunks = 0
 **/